import {Injectable} from '@angular/core';
import {WindowRefService} from './../window-ref.service';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import { TrackingService } from './tracking.service';
import {Subject} from 'rxjs/Subject';

@Injectable({
    providedIn: 'root'
})
export class LangueService {

    changeLangSubject = new Subject<any>();
    
    constructor(private translate: TranslateService, private winRef: WindowRefService,private TrackingService:TrackingService) {}

    public changeLang(value): Promise<any> {
        this.TrackingService.changeLang();
        let valueMapping: string = this.winRef.mappedLang(value);
        let promise = this.winRef.localeInitializer(valueMapping, value);
        promise.then((res) => {
            this.winRef.appConfigSite.defaultlangue = value;
            this.translate.use(value);
            this.translate.currentLang = value;
            this.changeLangSubject.next(value);
        });
        return promise;
    }
}
